<template>
  <div>
    <div v-if="device == 'h5'">
      <div class="page_foot" >
        <el-pagination background @size-change="handleSizeChange" small @current-change="handleCurrentChange"
          :current-page="page" layout=" prev, pager, next, slot" :page-size="size" :total="total">
          <template #default>
            <span class="total-text">共<span class="total-number">{{ total }}</span> 条</span>
          </template>
        </el-pagination>
      </div>
      <div style="text-align: center;" v-show="size*page<total">
        <el-button type="primary" @click="handleCurrentChange(page+1)">下一页</el-button>
      </div>
    </div>
    <el-row v-else>
      <el-col :span="24">
        <div class="block">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="page" :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500]"
            layout="total, sizes, prev, pager, next, jumper" :page-size="size" :total="total">
          </el-pagination>
        </div>
      </el-col>
    </el-row>


  </div>
</template>
<script>
export default {
  props: ['total'],
  data() {
    return {
      // 分页
      page: 1, // 当前页
      size: 10, // 每页条数
      device: "pc"
    };
  },
  mounted() {
    if (window.innerWidth < 1000) {
      this.device = 'h5'
    }
  },
  methods: {
    handleSizeChange(val) {
      this.page = 1;
      this.size = val;
      this.$emit('getList');
    },
    handleCurrentChange(val) {
      this.$nextTick(()=>{
        document.querySelector(".scrollbar").scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      })
      this.page = val;
      this.$emit('getList');
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4578ed;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
  background-color: #6993c7;
  color: #fff;
}

@media screen and (min-width: 1000px) {}

/* 针对手机的样式 */
@media screen and (max-width: 1000px) {
  .page_foot {
    position: fixed;
    right: 5px;
    background-color: #b9bdd061;
    width: 30px;
    top: 60%;
    transform: translateY(-50%);
    padding: 8px 1px;
    border-radius: 6px;
    z-index: 999;

    /deep/.el-pagination {
      display: flex;
      flex-wrap: wrap;
      padding: 2px 2px;
      .btn-prev {
        margin: 4px auto !important;
        transform: rotate(90deg);
      }

      .el-pager {
        display: flex;
        flex-wrap: wrap;
      }

      .total-text {
        writing-mode: tb;
        margin: 6px auto;
        font-size: 12px;
        line-height: 46px;
        height: 52px;
      }

      .total-number {
        writing-mode: horizontal-tb;
        margin: 3px auto;
        font-size: 12px;
        min-width: 48px;
      }

      text-align: center;

      .el-pagination__total {
        writing-mode: vertical-lr;
        margin: 4px auto 0 !important;
      }

      .btn-next {
        margin: 4px auto !important;
        transform: rotate(90deg);
      }

      .el-pager {
        flex-wrap: wrap;
        width: 100%;

        li {
          margin: 4px auto;
        }
      }
    }

    /deep/.el-card__footer {
      padding: 8px 12px
    }
  }
}
</style>
